<template>
    <v-navigation-drawer v-model="drawer" clipped fixed app>
        <v-list dense expand>
            <template v-for="(navItem, navIndex) in nav">
                <template v-if="isRoleValid(navItem)">
                    <v-list-group
                        v-if="navItem.children"
                        v-bind:key="navIndex"
                        :prepend-icon="navItem.icon"
                        no-action
                        :value="containActiveNav(navItem)"
                    >
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-title>{{ navItem.text }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <v-list-tile
                            v-for="(navSubItem, navSubIndex) in navItem.children"
                            v-bind:key="navSubIndex"
                            @click="redirectToPath(navSubItem)"
                            :class="comparePath(navSubItem.path)"
                        >
                            <template v-if="isRoleValid(navSubItem)">
                                <v-list-tile-action v-if="navSubItem.icon">
                                    <v-icon>{{ navSubItem.icon}}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ navSubItem.text }}</v-list-tile-title>
                            </template>
                        </v-list-tile>
                    </v-list-group>
                    <v-list-tile
                        v-if="!navItem.children"
                        v-bind:key="navIndex"
                        @click="navItem.path ? redirectToPath(navItem) : goToLink(navItem)"
                        :class="comparePath(navItem.path)"
                    >
                        <v-list-tile-action>
                            <v-icon>{{navItem.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{navItem.text}}</v-list-tile-title>
                    </v-list-tile>
                </template>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
    name: 'Navigation',
    data () {
        return {}
    },
    computed: {
        drawer: {
            get () {
                return this.$store.state.navigation
            },
            set (val) {
                this.$store.dispatch(this.$actionTypes.NAVIGATION, val)
            }
        },
        nav () {
            let nav = [
                {
                    text: this.$filters.capitalize(this.$t('console')),
                    icon: 'mdi-console',
                    children: [
                        {
                            text: this.$filters.capitalize(this.$t('dashboard')),
                            path: '/project/' + this.projectId + '/dashboard',
                            projectId: true
                        },
                        {
                            text: 'APIs',
                            path: '/project/' + this.projectId + '/apis',
                            projectId: true
                        },
                        {
                            text: 'API Keys',
                            path: '/project/' + this.projectId + '/credentials',
                            projectId: true
                        },
                        {
                            text: this.$filters.capitalize(this.$t('apiReport')),
                            path: '/project/' + this.projectId + '/history',
                            projectId: true
                        }
                    ]
                },
                {
                    text: this.$filters.capitalize(this.$t('applications')),
                    icon: 'mdi-application',
                    children: [
                        {
                            text: this.$filters.capitalize(this.$t('chatbot')),
                            path: '/application/chatbot'
                        },
                        {
                            text: this.$filters.capitalize(this.$t('Reader')),
                            path: '/application/reader'
                        },
                        {
                            text: this.$filters.capitalize(this.$t('VoiceMaker')),
                            path: '/application/voicemaker'
                        }
                    ]
                },
                {
                    text: this.$filters.capitalize(this.$t('postPaidPackageList')),
                    icon: 'mdi-page-layout-sidebar-right',
                    path: '/post-paid-package'
                },
                {
                    text: this.$filters.capitalize(this.$t('paymentHistory')),
                    icon: 'attach_money',
                    path: '/payment/history'
                },
                {
                    text: this.$filters.capitalize(this.$t('contactUs')),
                    icon: 'headset',
                    path: '/contact-us'
                },
                {
                    text: this.$filters.capitalize(this.$t('gettingStarted')),
                    icon: 'mdi-speedometer',
                    path: '/getting-started'
                },
                {
                    text: this.$filters.capitalize(this.$t('feedback')),
                    icon: 'mdi-message-reply-text',
                    path: '/feedback'
                },
                {
                    text: this.$filters.capitalize(this.$t('statistic')),
                    icon: 'mdi-google-analytics',
                    roles: [this.$const.roles.MARKETING],
                    children: [
                        {
                            text: this.$filters.capitalize(this.$t('general')),
                            path: '/analytics/general'
                        },
                        {
                            text: this.$filters.capitalize(this.$t('users')),
                            path: '/analytics/user'
                        },
                        {
                            text: this.$filters.capitalize(this.$t('projects')),
                            path: '/analytics/project'
                        }
                    ]
                },
                {
                    text: this.$filters.capitalize(this.$t('sales')),
                    icon: 'mdi-sale',
                    path: '/sales',
                    roles: this.$const.roles.SALE
                }
            ]
            // hide package history if there is no postpaid project
            if (!_.find(this.projects, item => item.project_type === this.$const.projectType.POSTPAID)) {
                _.remove(nav, item => item.text === this.$filters.capitalize(this.$t('postPaidPackageList')))
            }
            return nav
        },
        ...mapState({
            projectId: state => state.user.currentProjectId,
            projects: state => state.user.projects,
            userRoles: state => state.user.roles
        })
    },
    methods: {
        redirectToPath (navItem) {
            if (navItem.projectId) {
                if (!this.projectId) {
                    this.$appService.toastError(this.$t('noProjectSelectedError') + ' ' + navItem.text)
                    return
                }
            }
            let path = navItem.path
            this.$router.push(path)
        },
        goToLink (navItem) {
            window.location.href = navItem.link
        },
        comparePath (path) {
            return this.$route.path.includes(path) ? 'active_navigation' : ''
        },
        containActiveNav (navItem) {
            for (let item of navItem.children) {
                if (this.comparePath((item.path))) {
                    return true
                }
            }
            return false
        },
        isRoleValid (navItem) {
            if (navItem.roles) {
                let roles = Array.isArray(navItem.roles) ? navItem.roles : [navItem.roles]
                return _.difference(roles, this.userRoles).length < roles.length
            }
            return true
        }
    }
}
</script>
<style scoped>
    /deep/ .active_navigation {
        background: #f5ecec;
    }

    /deep/ .active_navigation .v-list__tile__title {
        color: #3BC1D4;
        /*font-weight: bold;*/
        transition: all linear 0s;
    }

    /deep/ .v-list__tile__title {
        color: #8D94AD;
        font-size: 14px;
        font-weight: normal;
    }

    /deep/ i {
        color: #8D94AD !important;
        caret-color: #8D94AD !important;
    }
</style>
